import {
	TownsquareGoalAri,
	TownsquareProjectAri,
	TownsquareSiteAri,
} from '@atlassian/ari/townsquare';

export function getSiteId(entity: 'project' | 'goal' | 'site', ari: string): string {
	try {
		if (entity === 'goal') {
			return TownsquareGoalAri.parse(ari).siteId;
		}

		if (entity === 'project') {
			return TownsquareProjectAri.parse(ari).siteId;
		}

		if (entity === 'site') {
			return TownsquareSiteAri.parse(ari).siteId;
		}
	} catch (error) {
		//TODO: send error metrics/monitoring https://product-fabric.atlassian.net/browse/TC-13492

		//We try to extract the siteId manually: ari:cloud:townsquare:${siteId}:{entity}/{uuid}
		if (entity === 'goal' || entity === 'project') {
			return ari.split(':')[3] ?? '';
		}
	}
	return '';
}
